import React, { useContext, useEffect } from "react"
import { useState } from "react"
import Context from "../utils/Context"
import { watchEndOfMission, mapFeedInfo } from "../utils/ROS/ROSFunctions"


const GlobalModal = () => {
  const context = useContext(Context)
  const [missionStatus, setMissionStatus] = useState(null)



  // end current mission
 /*useEffect(() => {
    if (context.currentMission && context.endOfMission && context.selectedRobot.typeRobot !== "FI-250") {
      cancelActions({ stopall: true })
    }
  }, [context.endOfMission, context.currentMission])*/

  // found people
  useEffect(() => {
    if (context.currentTask) {
      if (context.foundPeople) {
        //console.log("found people")
        setMissionStatus("foundPeople")
        //context.actions.setCurrentTask(null)
      }
    }
    // console.log("global modal", context.currentMission, context.foundPeople)
  }, [context.foundPeople, context.actions, context.currentTask])

  // reset mission
  const resetMission = () => {
    context.actions.setEndOfMission(null)
    setMissionStatus(false)
    context.actions.setFoundPeople(false)
  }

  // modal message
  let modalMessage
  switch (missionStatus) {
    case "cancelled": modalMessage = "Task was cancelled"; break
   // case "finished": modalMessage = "Mission has finished successfully"; break
    case "foundPeople": modalMessage = "UV Task aborted, person detected"; break
    default:
  }

  // test sonae mission generation
  // const generateMission = async () => {
  //   console.log("calling api with data", {robotId: "5f05d2227b2aa706576cbe71", orderCode: "A36BE304-33E7-4A4D-ACEF-42CC50F3B8DF"})
  //   const result = await api.generateSonaeMission({robotId: "5f05d2227b2aa706576cbe71", orderCode: "A36BE304-33E7-4A4D-ACEF-42CC50F3B8DF"})
  //   console.log("generate sonae mission result", result)
  // }
  // useEffect(() => {
  //   generateMission()
  // }, [])

  return (
    <div>

      {(missionStatus && missionStatus !== "executing") &&

        <div id="modal" className="modal is-active">
          <div className="modal-background"></div>
          <div className="modal-card">

            <header className="modal-card-head">
              <p className="modal-card-title">
                Mission Status
                </p>
              <button className="delete" aria-label="close"></button>
            </header>

            <section className="modal-card-body">
              <p>
                {modalMessage}
              </p>
            </section>

            <footer className="modal-card-foot">
              <button className="button" onClick={resetMission}>
                Ok
                </button>
            </footer>

          </div>
        </div>
      }
    </div>
  )
}

export default GlobalModal
